






import React from "react"
import { Link } from 'react-router-dom'




export class MobileMenu extends React.Component {
    open = false
    mobileMenuButton = React.createRef()
    mobileMenu = React.createRef()

    render() {
        return (
            <div className="drop-menu-btn" onClick={_ => {
                    this.open ^= true
                    this.mobileMenuButton.current.className = this.open
                        ? 'active'
                        : ''
                    this.mobileMenu.current.classList.toggle('closed', !this.open)
                }}>
                <div type="checkbox" id="hamburgerx" className="btn-wrap"
                />
                <label htmlFor="hambugerx">
                    <ul ref={this.mobileMenuButton} >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </label>
                <div ref={this.mobileMenu} className="list closed">
                    <div comment="create nodes"><Link to="/create">Create</Link></div>
                    {/* <div comment="view library modules"><Link to="/">Explore</Link></div> */}
                    <div comment="create own modules"><Link to="/experiment">Experiment</Link></div>
                    {/* <div>Documentation</div> */}
                    <div><Link to="/newsupdates">Release Notes</Link></div>
                </div>
            </div>)
    }
}